document.addEventListener( 'DOMContentLoaded', function() {
  if($('#js-mv').length) {
    var splide =  new Splide( '#js-mv', {
      type      : 'loop',
      focus     : 'center',
      autoWidth : true,
      padding: '20%',
      pagination: true,
      autoplay: true,
      interval: 4000,
      breakpoints: {
        750: {
          autoWidth : false,
          padding: '0%',
        },
      }
    } );
    splide.mount();
  }
});
document.addEventListener( 'DOMContentLoaded', function() {
  if($('#js-recommend').length) {
    var splide =  new Splide( '#js-recommend', {
      type      : 'loop',
      focus     : 'center',
      autoWidth : false,
      gap       : '25px',
      arrows    : false,
      pagination: true,
      padding: '15%',
      autoplay: true,
      interval: 4000,
      breakpoints: {
        750: {
          destroy: true,
        },
      }
    } );
    splide.mount();
  }
});
jQuery(function ($) {
  tabParent = $('.delivery__item__head'),
  tabChild = $('.delivery__item__content')

  $(tabParent).on("click", function() {
    $(this).next(tabChild).slideToggle(500);
    $(this).toggleClass('is-tap');
    if (!($(this).hasClass('is-tap'))) {
      $(this).removeClass('is-tap');
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.js-product-slider');
  if (!sliders.length) return;

  sliders.forEach(function (slider) {
    var splide = new Splide(slider, {
      type       : 'loop',
      arrows     : true,
      pagination : false,
      drag       : true,
      focus      : 'center',
      autoWidth  : false,
      fixedWidth : '43%',
      gap        : '1.4rem',
      trimSpace  : false,
      padding    : '0',
      mediaQuery : 'min',
      breakpoints: {
        750: {
          destroy: true,
        },
      },
    });

    splide.mount();
  });
});